import React, { useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";

import { login, signFailed, loginNumber } from "../../redux/actions/auth";

import { Link, useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";

import { toast, ToastContainer } from "react-toastify";
import LoginLoader from "../../components/LoginLoader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import StarsIcon from "@mui/icons-material/Stars";
import CancelIcon from "@mui/icons-material/Cancel";
import SendIcon from "@mui/icons-material/Send";

import "../../assets/css/style.css";
import man from "../../assets/images/avatar.png";
import {
  IconButton,
  InputAdornment,
  ThemeProvider,
  createTheme,
  Backdrop,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";

import Loader from "../../components/Loader";

import { useSelector } from "react-redux";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import axios from "axios";
import { useEffect } from "react";
import Swal from "sweetalert2";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const customId1 = "custom-id-yess";
function LoginInTheHouse(props) {
  const history = useHistory();
  // const [open, setOpen] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openn, setOpenn] = React.useState(false);
  const [isOpenOtp, setIsOpenOtp] = useState(false);
  const [value, setValue] = React.useState(0);
  const [verified, setVerified] = useState(false);
  const [contactus, setContactus] = useState({
    name: "",
    email: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  //   const [hideshow, setHideShow] = useState({
  //     password:'',
  //     o
  //   });
  const [type, setType] = useState(true);
  const [signType, setSignType] = useState(true);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const theme = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  const handleClickOpen = () => {
    setOpenn(true);
  };

  const handleClose = () => {
    setOpenn(false);
  };

  const forgotRef = useRef(null);

  const forgotModal = () => {
    forgotRef.current.click();
  };
  const forgotRefmodal = useRef(null);

  const Datee = useSelector((state) => state?.dashboardReducer?.timeSeries);
  const array = useSelector((state) => state?.usersReducer);

  const dispatch = useDispatch();



  const [values, setvalues] = useState({
    username: "",
    password: "",
  });

  const formsubmit = (e) => {
    e.preventDefault();
    try {
      if (type) {
        // return props.login(String(values.username), values.password);
        return props.login(String(values.username), values.password);
      }

      props.login(Number(values.username), values.password);
    } catch (error) {
      console.log(error);

      // await toast.error("Something Went Wrong", {
      //   theme: "colored",
      //   customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!! Please check your network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };






  const validationSchema = yup.object({
    username: yup
      .string("Enter Your Username")
      .required("Field is required")
      .min(3, "Username should be at least 3 characters long")
      .matches(/^(\S+$)/g, "This field cannot contain blankspaces")
      .when("type", () => {
        if (!isNaN(type)) {
          return yup
            .string()
            .required("Phone Number is required")
            .min(6, "Phone Number should be of minimum 6 characters length")
            .max(9, "Phone Number should be of minimum 9 characters length")
            .matches(/^(\S+$)/g, "This field cannot contain  blankspaces");
        }
      }),
    password: yup
      .string("Enter your password")
      .min(2, "Password should be of minimum 2 characters length")
      .required("Password is required")
      .when("type", () => {
        if (!isNaN(type)) {
          return yup.string();
        }
      }),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        if (type) {
          return props.login(String(values.username), values.password, value);
        }

        props.login(Number(values.username), values.password, value);
      } catch (error) {
        console.log(error);

        // await toast.error("Something Went Wrong", {
        //   theme: "colored",
        //   customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });

  const submit = useRef(null);

  const submitapi = () => {
    submit.current.click();
  };

  const formik1 = useFormik({
    initialValues: {
      otp: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    validationSchema: yup.object({
      otp: yup
        .string()
        .required("OTP is required")
        .min(4, "OTP should be minimum  4 characters long")
        .max(4, "OTP should be maximum  4 characters long")
        .matches(/^(\S+$)/g, "This field cannot contain blankspaces"),
    }),

    onSubmit: async (values) => {
      try {
        return props.loginNumber(values.otp);
      } catch (error) {
        console.log(error);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });

  // const sendOtp = async () => {
  //   try {
  //     setOpen(true);
  //     const xCheckSumValues = xCheckSumIdGernator(formik.values.username);
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_COMMON_API}/auth/v1/pin/generate`,

  //       {
  //         // msisdn: Number(parseData.mobile),
  //         msisdn: Number(formik.values.username),
  //         requestId: xCheckSumValues.generator,
  //         isDebug: false,
  //       },
  //       {
  //         headers: {
  //           "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
  //         },
  //       }
  //     );
  //     if (res.data.statusDescription.statusCode == 200) {
  //       setOpen(false);
  //       localStorage.setItem("transactionId", res.data.transactionId);
  //       localStorage.setItem("msisdn", res.data.msisdn);
  //       await toast.success("Otp Sent Successfully", {
  //         theme: "colored",
  //         customId1,
  //       });
  //       setIsOpenOtp(true);
  //     } else {
  //       setOpen(false);
  //       await toast.error(res.data.statusDescription.description, {
  //         theme: "colored",
  //         customId1,
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);

  //     await toast.error("Something Went Wrong", {
  //       theme: "colored",
  //       customId1,
  //     });
  //     setOpen(false);
  //   }
  // };

  const modalContact = useRef(null);
  const modalContactClose = useRef(null);

  const contactModal = async () => {
    await modalContact.current.click();
  };









  const forgotPassword = async (e) => {
    e.preventDefault();
    if (window.localStorage.getItem("token")) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Already !! Logged in from another tab",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } else {
      try {
        setOpen(true);

        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/api/auth/v1/forgotPassword`,
          {
            userName: contactus.name,
            email: contactus.email,
          }
        );

        if (res.data.statusDescriptions.statusCode == 200) {
          setOpen(false);

          await handleClose();
          await setTimeout(() => {
            // toast.success(res.data.statusDescriptions.statusDescription, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "success",
              // title: "Oops...",
              text: res.data.statusDescriptions.statusDescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
          localStorage.setItem(
            "tokennn",
            res.data.forgotPasswordResponses.token
          );
          localStorage.setItem(
            "username",
            res.data.forgotPasswordResponses.username
          );
          localStorage.setItem("id", res.data.forgotPasswordResponses.userId);
          await forgotRefmodal.current.click();
        } else {
          setOpen(false);
          // await handleClose();
          await setTimeout(() => {
            // toast.error(res.data.statusDescriptions.statusDescription, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res.data.statusDescriptions.statusDescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
          await forgotRefmodal.current.click();
        }
      } catch (error) {
        setOpen(false);
        // await handleClose();

        await forgotRefmodal.current.click();

        // await toast.error("Something Went Wrong ! Please check your network", {
        //   theme: "colored",
        //   customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };
  // useEffect(() => {
  //   if ((window.location = `/`))
  //     window.history.pushState(null, null, window.location.href);
  //   window.onpopstate = function () {
  //     window.history.go();
  //   };
  // }, []);

  return (
    <>
      <body class="g-sidenav-show login_8 bg-gray-200 bg_gradient">
        {localStorage.getItem("token") ? null : (
          <>
            <button
              ref={forgotRef}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop9"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop9"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Reset Password
                    </h5>
                    <button
                      ref={forgotRefmodal}
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        setContactus({
                          name: "",
                          email: "",
                        });
                      }}
                    ></button>
                  </div>
                  <form onSubmit={forgotPassword}>
                    <ThemeProvider theme={theme}>
                      <div className="modal-body" id="reset_pwd_modal">
                        <div className="row">
                          <div className="col-md-9">
                            <div className="d-flex align-items-center">
                              <label
                                className="m-0"
                                htmlFor=""
                                style={{ whiteSpace: "nowrap" }}
                              >
                                E-Mail
                              </label>
                              <input
                                class="form-control w-100 ms-4"
                                type="email"
                                required
                                value={contactus.email}
                                onChange={(e) => {
                                  setContactus({
                                    ...contactus,
                                    email: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-9">
                            <div className="d-flex align-items-center">
                              <label
                                className="m-0"
                                htmlFor=""
                                style={{ whiteSpace: "nowrap" }}
                              >
                                Username
                              </label>
                              <input
                                required
                                class="form-control w-100 ms-4"
                                type="text"
                                value={contactus.name}
                                onChange={(e) => {
                                  setContactus({
                                    ...contactus,
                                    name: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </ThemeProvider>
                    <div className="px-2 pb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <Button
                          data-bs-dismiss="modal"
                          sx={{ marginLeft: "10px", background: "#4C4234" }}
                          variant="contained"
                          endIcon={<CancelIcon />}
                          onClick={() => {
                            setContactus({
                              name: "",
                              email: "",
                            });
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          type="submit"
                          variant="contained"
                          sx={{ background: "#F96B02", color: "white" }}
                          endIcon={<SendIcon />}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </>
        )}
        <div class="login-bg" id="login-bg">
          <ToastContainer autoClose={5000} />
          <ThemeProvider theme={theme}>
            <Backdrop
              sx={{
                transform: "translateZ(0)",
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={open}
            >
              <Loader />
            </Backdrop>

            <main class="main-content my-aut lgin_cntnt position-relative w-auto  border-radius-l  ">
              <div>
                {/* <Dialog
                  fullScreen
                  open={openn}
                  onClose={handleClose}
                  TransitionComponent={Transition}
                >
                  <div>
                    <List>
                      <div
                        style={{
                          marginTop: "13%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <form
                          onSubmit={forgotPassword}
                          class="form"
                          id="form_f"
                        >
                          <a href="#" onClick={handleClose} class="close">
                            &times;
                          </a>
                          <h2>Reset Password</h2>
                          <div className="row">
                            <div class="input-group col-md-6">
                              <input
                                type="email"
                                name="email"
                                id="email"
                                required
                                onChange={(e) => {
                                  setContactus({
                                    ...contactus,
                                    email: e.target.value,
                                  });
                                }}
                              />
                              <label for="email">Email</label>
                            </div>
                            <div class="input-group col-md-6 mt-3">
                              <input
                                type="text"
                                name="username"
                                // id="email"
                                required
                                onChange={(e) => {
                                  setContactus({
                                    ...contactus,
                                    name: e.target.value,
                                  });
                                }}
                              />
                              <label for="email">Username</label>
                            </div>
                          </div>
                          <input
                            type="submit"
                            // onClick={() => {
                            //   submitapi();
                            // }}
                            value="Submit"
                            class="submit-btn mt-4"
                          />
                        </form>
                      </div>
                    </List>
                  </div>
                </Dialog> */}
              </div>
              <div class="login-wrapper">
                <form 
                // onSubmit={formik.handleSubmit}
                onSubmit={formsubmit}
                 class="form" id="form_f">
                  <img src={man} alt="" />
                  <h3 className="text-center text-white fw-bold ">
                    ALTRACIA - HRMS
                  </h3>
                  <h2>Login</h2>
                  {/* <div class="input-group">
               
                    <TextField
                      inputProps={{
                        style: { color: "white" },
                      }}
                      InputLabelProps={{
                        style: { color: "#fff" },
                      }}
                      autoFocus={true}
                      required
                      className="w-100"
                      label="Username/Payroll-Id"
                      name="username"
                      autoComplete="off"
                      variant="standard"
                      size="small"
                      value={formik.values.username}
                      onChange={(e) => {
                        setType(e.target.value);
                        formik.handleChange(e);
                      }}
                      error={
                        formik.touched.username &&
                        Boolean(formik.errors.username)
                      }
                      helperText={
                        formik.touched.username && formik.errors.username
                      }
                    />
                   
                  </div>
                  <div class="input-group">
                  
                    <TextField
                      InputLabelProps={{
                        style: { color: "#fff" },
                        // shrink: true,
                      }}
                      required
                      inputProps={{
                        style: { color: "white" },
                      }}
                      className="w-100"
                      label="Password"
                      name="password"
                      // autoComplete="new-password"
                      type={showPassword ? "text" : "password"}
                      variant="standard"
                      size="small"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityIcon sx={{ color: "#FF652F" }} />
                              ) : (
                                <VisibilityOffIcon sx={{ color: "#FF652F" }} />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                   
                  </div> */}

                  <div className="col-auto">
                    <label
                      for="inputPassword2"
                      className="wifiLable text-white"
                    >
                     Username/Payroll-Id
                    </label>
                    <input
                      type="text"
                      name="profile_name"
                      required
                      id="profile_name inputPassword2"
                      className="form-control required p-2 text-white"
                      // placeholder="Enter Profile Name"
                      value={values?.username}
                      onChange={(e) => {
                        setvalues({ ...values, username: e.target.value });
                      }}
                    />
                  </div>

                  <div className="row mt-3">
                    {/* <TextField
                        InputLabelProps={{
                          style: { color: "#fff" },
                          // shrink: true,
                        }}
                        required
                        inputProps={{
                          style: { color: "white" },
                          autoComplete: "new-password",
                        }}
                        variant="standard"
                        size="small"
                        id="outlined-basic1"
                        autoFocus={true}
                        label="Password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.password &&
                          Boolean(formik.errors.password)
                        }
                        helperText={
                          formik.touched.password && formik.errors.password
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword ? (
                                  <VisibilityIcon sx={{ color: "#80c5ff" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ color: "#80c5ff" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      /> */}

                    <div className="col-12">
                      <label
                        for="inputPassword2"
                        className="wifiLable text-white"
                      >
                        Password
                      </label>
                      <div className="d-flex" id="boot_input">
                        <input
                          required
                          type={showPassword ? "text" : "password"}
                          className="form-control p-2 text-white"
                          id="passwordifany"
                          style={{
                            borderBottomRightRadius: "0px",
                            borderTopRightRadius: "0px",
                          }}
                          // placeholder="Enter Profile Password"
                          autocomplete="new-password"
                          // value={values?.password}
                          // onBlur={(e) => {
                          //   if (pattern.test(e.target.value)) {
                          //     // console.log("11", "true", e.target.value);

                          //     setcheckpass(false);
                          //   } else {
                          //     // console.log("11", "false", e.target.value);
                          //     if (e.target.value) {
                          //       setcheckpass(true);
                          //     }
                          //   }
                          // }}
                          onChange={(e) => {
                            setvalues({
                              ...values,
                              password: e.target.value,
                            });
                          }}
                        />
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          style={{
                            backgroundColor: "rgb(232 240 254 / 26%)",
                            borderRadius: "0 0.375rem 0.375rem 0",
                          }}
                        >
                          {showPassword ? (
                            <VisibilityIcon sx={{ color: "#1990d0" }} />
                          ) : (
                            <VisibilityOffIcon sx={{ color: "#1990d0" }} />
                          )}
                        </IconButton>
                      </div>
                      {/* {checkpass ? (
                          <>
                            {" "}
                            <span
                              className=""
                              style={{ fontSize: "12px", color: "red" }}
                            >
                              Invalid Password
                            </span>
                          </>
                        ) : (
                          <></>
                        )} */}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-5">
                    {localStorage.getItem("token") ? (
                      <Link
                        onClick={() => {
                          // toast.error("Please Logout From Previous Session", {
                          //   theme: "colored",
                          // });
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Please Logout From Previous Session",
                            // footer: '<a href="">Why do I have this issue?</a>'
                          });
                        }}
                        class="forgot-pw"
                      >
                        Forgot Password?
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          handleClickOpen();
                          forgotModal();
                        }}
                        class="forgot-pw"
                      >
                        Forgot Password?
                      </Link>
                    )}
                    <input type="submit" value="Login" class="submit-btn m-0" />
                  </div>
                </form>
              </div>
              <LoginLoader visible={props.loading} />
            </main>
          </ThemeProvider>
        </div>
      </body>
    </>
  );
}

const mapStateToProps = (state) => ({
  loading: state.authReducer.loading,
});

const mapDispatchToProps = (dispatch) => ({
  loginNumber: (otp) => dispatch(loginNumber(otp)),
  login: (username, password, accountType) =>
    dispatch(login(username, password, accountType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginInTheHouse);
